import service from './request'

//保存坐席预约回访记录
export const saveAgentPlanReturnVisitRec = data => {
  return service({
    url: "/cc/popScreen/saveAgentPlanReturnVisitRec",
    method: "post",
    type: 'body',
    data
  });
};

//获取预约回访列表
export const getAgentPlanReturnVisitRec = data => {
  return service({
    url: "/cc/popScreen/getAgentPlanReturnVisitRec",
    method: "post",
    type: 'body',
    data
  });
};

//更新预约标识
export const setAgentPlanReturnVisitFlag = data => {
  return service({
    url: "/cc/popScreen/setAgentPlanReturnVisitFlag",
    method: "post",
    type: 'body',
    data
  });
};

//获取坐席电话历史记录
export const getAgentHistoryRec = data => {
  return service({
    url: "/cc/popScreen/getAgentHistoryRec",
    method: "post",
    type: 'body',
    data
  });
};

//获取来电弹屏URL信息
export const getPopUrlInfo = data => {
  return service({
    url: "/cc/popScreen/getPopUrlInfo",
    method: "post",
    data
  });
};

//获取客户历史记录
export const getCusHistoryRec = data => {
  return service({
    url: "/platform/busi/getCusHistoryRec",
    method: "post",
    type: 'body',
    data
  });
};

//会话标签标识
export const saveData = data => {
  return service({
    url: "/platform/sessionLable/cfg/saveData",
    method: "post",
    type: 'body',
    data
  });
};

//获取会话的标签信息
export const getSessionLabBySid = data => {
  return service({
    url: "/platform/sessionLable/cfg/getSessionLabBySid",
    method: "post",
    type: 'body',
    data
  });
};

//获取客户信息
export const getCusInfo = data => {
  return service({
    url: "/platform/busi/getCusInfo",
    method: "post",
    type: 'body',
    data
  });
};

//保存访客与客户关系
export const saveVisitorAndCusRelation = data => {
  return service({
    url: "/platform/busi/saveVisitorAndCusRelation",
    method: "post",
    type: 'body',
    data
  });
};

//保存会话与工单关系
export const saveSessionAndOrderRelation = data => {
  return service({
    url: "/platform/busi/saveSessionAndOrderRelation",
    method: "post",
    type: 'body',
    data
  });
};


// WEBPACK FOOTER //
// ./src/http/HotLineCall.js